import { useCallback } from 'react';
import { useSetCursor } from '../useSetCursor';
import { Cursor } from 'src/components/Map/map.types';

export const useOnDragStart = () => {
  const setCursor = useSetCursor();
  return useCallback(() => {
    setCursor(Cursor.grabbing);
  }, [setCursor]);
};
